import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import { IconProps } from "./types";

export function CircleIcon({ size, ...props }: IconProps) {
    return <CircleRoundedIcon fontSize={size} {...props} />;
}
